import { useCallback } from "react";
import api from "../../services/api";

const useUserNotifications = () => {
  const list = useCallback(async ({ pageNumber = 1, pageSize = 20, onlyUnread = false } = {}) => {
    const { data } = await api.get("/user-notifications", {
      params: { pageNumber, pageSize, onlyUnread }
    });
    return data;
  }, []);

  const unreadCount = useCallback(async () => {
    const { data } = await api.get("/user-notifications/unread-count");
    return data;
  }, []);

  const markAsRead = useCallback(async (id) => {
    const { data } = await api.put(`/user-notifications/${id}/read`);
    return data;
  }, []);

  const markAllAsRead = useCallback(async () => {
    const { data } = await api.put("/user-notifications/read-all");
    return data;
  }, []);

  return { list, unreadCount, markAsRead, markAllAsRead };
};

export default useUserNotifications;
